import { Stack, IconButton, Box } from "@mui/material";
import { Search } from "@mui/icons-material";
import InputText from "@/components/form/InputText";
import { useState } from "react";
import { useForm } from "react-hook-form";

export function SearchQuestionnaire({ searchTerm, setSearchTerm }: { searchTerm: string, setSearchTerm: (searchTerm: string) => void }) {
    const [searchExpanded, setSearchExpanded] = useState(true);
    const { control } = useForm({
        defaultValues: {
            searchTerm: searchTerm
        }
    });
    return (
        <Stack direction="row" alignItems="center" gap={1} sx={{ flex: 1, minWidth: 0 }}>
            <IconButton
                color="primary"
                onClick={() => setSearchExpanded(!searchExpanded)}
                aria-label={searchExpanded ? "Fechar busca" : "Abrir busca"}
                size="medium"
            >
                <Search fontSize="medium" />
            </IconButton>
            <Box
                sx={{
                    flex: searchExpanded ? 1 : 0,
                    minWidth: 0,
                    maxWidth: searchExpanded ? "100%" : 0,
                    my: searchExpanded ? 1 : 0,
                    overflow: "hidden",
                    transition: "max-width 0.28s ease-out, flex 0.28s ease-out, margin 0.28s ease-out",
                }}
            >
                <InputText
                    name="searchTerm"
                    control={control}
                    placeholder="Buscar questionários por título, descrição ou editor..."
                    defaultValue={searchTerm}
                    handleChange={(event: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(event.target.value)}
                    sx={{
                        "& .MuiInputBase-root": {
                            fontSize: "0.875rem",
                            height: 44,
                            minHeight: 44,
                        },
                        "& .MuiInputBase-input": {
                            py: 0.75,
                        },
                    }}
                />
            </Box>
        </Stack>
    );
}